// extracted by css-extract-rspack-plugin
export default {"inputs":"VCNldS","display-resolution":"chYok7","displayResolution":"chYok7"};